var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-selector',_vm._b({attrs:{"items":_vm.items,"item-text":item =>
      `${item.attributes.iccEce.toUpperCase()} [${item.attributes.code}] `,"item-value":"attributes.code"},on:{"input":function($event){return _vm.$emit('input', $event)}}},'base-selector',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }